import React, { useContext } from 'react';

//component
import SimpleTable from  '@/components/elements/global/tables/SimpleTable/SimpleTable';
import ArchiveContentModal from  '@/components/modals/content/ArchiveContentModal';

//context
import { MainMenuListContext } from '../../../context/MainMenuListContext';
import { ListContext } from '@/context/ListContext';
import { mainMenuTableColumns } from './ListConstants';



const MainMenuTable = () => {
    const {formatTableRows, showArchiveModal, setShowArchiveModal, onArchiveItemClick, contentExistsInMultipleLocations, displayMainMenuTable, getMoreMenuItems, moreAvailable, isLoading, paginationSettings} = useContext(MainMenuListContext)
    const {hasEditorRights} = useContext(ListContext)

    if (!displayMainMenuTable){
        return <></>
    }
    return (
        <>
            <SimpleTable 
                simpleTableContent={{columns: mainMenuTableColumns, rows: formatTableRows()}} 
                isInfiniteScroll={true}
                getMoreContent={getMoreMenuItems}
                isDragAndDrop={hasEditorRights && formatTableRows().length > 1}
                noDataMessage="No items to display"
                infiniteScrollFetchCondition={moreAvailable}
                isLoading={isLoading}
                paginationInformation={paginationSettings}
                isPaginated={false}
            />
        
            <ArchiveContentModal showModal={!!showArchiveModal} hideModal={() => setShowArchiveModal(null)} contentExistsInMultipleLocations={contentExistsInMultipleLocations} onArchiveItemClick={() => onArchiveItemClick()} />
        </>
    )
}

export default MainMenuTable